import { authRedirectGuard } from './auth-redirect.guard';
import { mfaAvailabilityGuard } from './mfa-availability.guard';
import { serialCanActivate } from '@xt/core/utils';

/**
 * A composite guard that checks for basic authentication and MFA status.
 * It runs the following guards in sequence:
 * 1. `authRedirectGuard`: Handles initial authentication check and recovery mode.
 * 2. `mfaAvailabilityGuard`: Checks the user's MFA status and redirects if setup is needed.
 */
export const twoFactorAuthCompletedGuard = serialCanActivate(
  authRedirectGuard,
  mfaAvailabilityGuard,
);
